import { render, staticRenderFns } from "./applicationUsersForbidden.vue?vue&type=template&id=4d4def4f&scoped=true"
import script from "./applicationUsersForbidden.vue?vue&type=script&lang=js"
export * from "./applicationUsersForbidden.vue?vue&type=script&lang=js"
import style0 from "./applicationUsersForbidden.vue?vue&type=style&index=0&id=4d4def4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4def4f",
  null
  
)

export default component.exports